<template>
  <div>
       <Layout/>
       <v-container grid-list-md  >
		<notifications position="bottom center" />
		<v-layout row wrap>
			<v-flex xs12>

			<v-toolbar flat color="white" class="elevation-1">
				<v-toolbar-title>{{title}}</v-toolbar-title>
				<v-divider class="mx-2" inset vertical></v-divider>
				<v-spacer></v-spacer>
				<v-text-field
					v-model.lazy="search"
					append-icon="search"
					label="Buscar"
					single-line
					hide-details
					class="hidden-md-and-down"
				></v-text-field>
				<v-spacer></v-spacer>
				<v-btn color="primary" dark class="mb-2" @click="openProductForm({})">Novo</v-btn>
			</v-toolbar>

				<v-data-table
					:headers="columns"
					:items="items"
      				:loading="loading"					
					class="elevation-1" 
				>
					<template v-slot:item.action="{ item }">
						<v-icon
							small
							class="mr-2"
							@click="openProductForm(item)"
						>
							edit
						</v-icon>
						<v-icon
							small
							@click="deleteItem(item)"
						>
							delete
						</v-icon>
					</template>
					<template slot="no-data">
						Desculpe, nenhum dado para ser exibido!
					</template>
				</v-data-table>
				

			</v-flex>
		</v-layout>

		<div v-if="productFormActive.open">
			<product-form
				:active="productFormActive.open"
				:item="productFormActive.item"
				:finish="onCloseProductForm"
                :category="productFormCategory"
                ></product-form>
		</div>

  </v-container>
</div>
</template>

<script>
import _ from 'lodash';
export default {
  data() {
		return {
            search: '',
            title: '',
            category: 1,
      		pagination: {
				totalItems: 0,
				rowsPerPage: 10,
				ascending: false,
				page: 1,
				sortBy: 'id'
			},
			items: [],
			columns: [
				{ value: 'id', text: 'ID' },
				{ value: 'name', text: 'Nome', },
				{ value: 'price', text: 'Preço'},			
				{ text: '', value: 'action', sortable: false },
			],
			productFormActive: { open: false, item: {} },
			loading: false,
		}
	},
	computed: {
		pages () {
			if (this.pagination.rowsPerPage == null ||
				this.pagination.totalItems == null
			) return 0

			return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        },
        
        
        
	},
	watch: {
		"pagination.page": {
			handler () {
				this.getList();
			},
			deep: true
        },
		search: function () {
      	this.debounceInput();
    }
	},
	created () {
		this.initialize();
	},
	methods: {
		initialize () {
            this.getList();
            this.categoryView();
        },
        categoryView(){
            let category = 1;
            console.log(category);
            switch(category){
                case '1': 
                    this.title = "Pratos"; 
                break;
                case '2': 
                    this.title = "Bebidas";  
                break;
                case '3': 
                    this.title = "Sobremesa";  
                break;
            }
        },
		getList() {
			this.loading = true
			return new Promise((resolve, reject) => {
				const params = {
					...this.pagination,
					totalItems: undefined,
					search: this.search
				};
				this.$http.get(`/products/list/${this.category}`, {params})
				.then(response => response.data).then(json => {
					setTimeout(() => {
            		this.loading = false;
					this.items = json.items;
					this.pagination.totalItems = json.total;
         	 }, 1000);
				}).catch(() => this.loading = false);
			});
		},
		openProductForm(item) {
			this.productFormActive.open = true;
            this.productFormActive.item = item;
            this.productFormCategory =  this.category;
		},
		onCloseProductForm() {
			this.productFormActive.open = false;
			this.getList();
		},
		deleteItem(item) {
			console.log(item.id);

			if (confirm(`Deseja realmente excluir ${item.name}?`)) {
				this.$http.delete(`/products/${item.id}`)
				.then(response => {
					this.$notify({
						title: `Produto Excluido!`,
						type: 'error',
					});
					this.getList();
				});
			}
		},
		debounceInput: _.debounce(function () {
      		setTimeout(() => {this.getList();}, 200);
		}, 400)
	}
}
</script>
